import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import React from "react";

// internal imports

const SubscribeTable = ({ subscribe, perpage, currentPage, tab }) => {
  return (
    <>
      <TableBody>
        {subscribe?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="font-semibold text-center uppercase text-xs">
              <span>{(currentPage - 1) * perpage + index + 1}</span>
            </TableCell>

            <TableCell className="text-sm text-center">
              <span>{data.email}</span>
            </TableCell>

            <TableCell className="text-center">
              <span
                className={`text-sm ${
                  data.active === 1 ? "text-green-500" : "text-red-500"
                }`}
              >
                {data.active === 1 ? "Active" : "Inactive"}
              </span>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default SubscribeTable;
